import { render, staticRenderFns } from "./ReceivableVendor.vue?vue&type=template&id=54039362&scoped=true&"
import script from "./ReceivableVendor.vue?vue&type=script&lang=js&"
export * from "./ReceivableVendor.vue?vue&type=script&lang=js&"
import style0 from "./ReceivableVendor.vue?vue&type=style&index=0&id=54039362&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54039362",
  null
  
)

export default component.exports